export default {
  selectColor: 'var(--base-brown)',
};
